<div class="logo-section">
  <div class="white-section-left"></div>
  <div class="white-section-right"></div>
  <img src="/../assets/img/landing-page/figaro-etudiant.jpg" alt="Logo - figaro étudiant">
  <img src="/../assets/img/landing-page/skema.jpg" alt="logo - SKEMA Venture">
  <img src="/../assets/img/landing-page/neoma.png" alt="logo - NEOMA Incubator">
</div>
